import * as types from "./mutation-type";

export default {
    [types.SET_LOCATION](state, payload) {
        state.location = payload
    },
    [types.SET_STREET_NAME](state, payload) {
        state.street_name = payload
    },
    [types.SET_STREET_NUMBER](state, payload) {
        state.street_number = payload
    },
    [types.SET_NEIGHBORHOOD](state, payload) {
        state.neighborhood = payload
    },
    [types.SET_POSTAL_CODE](state, payload) {
        state.postal_code = payload
    },
    [types.SET_CITY](state, payload) {
        state.city = payload
    },
    [types.SET_UF](state, payload) {
        state.uf = payload
    },
    [types.SET_COUNTRY](state, payload) {
        state.country = payload
    },
    [types.SET_LATITUDE](state, payload) {
        state.latitude = payload
    },
    [types.SET_LONGITUDE](state, payload) {
        state.longitude = payload
    },
    [types.SET_USER_ID](state, payload) {
        state.user_id = payload
    }
}
